import React, { useContext } from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
import { CalculatorContext } from '../../CalculatorContext';
import { MIN_PAD_PRICE } from '../../../../constants';

const { number } = proptypes;

const calculateEstimatedTotal = (coverage, sqFtPrice) => parseInt(coverage * (sqFtPrice + MIN_PAD_PRICE), 10);

const roundUpEstimatedTotal = (total) => {
  if (total < 100) return total;
  const roundToNearestVal = total < 1000 ? 50 : 100;
  const roundedPrice = Math.round(total / roundToNearestVal) * roundToNearestVal;

  if (roundedPrice >= total) return roundedPrice;
  return roundedPrice + roundToNearestVal;
};

export const EstimatedTotal = ({ sqFtPrice }) => {
  const { calculate } = useContext(CalculatorContext);
  const { coverage } = calculate;

  if (!coverage || !sqFtPrice) {
    return null;
  }
  const total = calculateEstimatedTotal(coverage, sqFtPrice);
  const estimatedTotal = roundUpEstimatedTotal(total);
  return (
    <section className="sui-border-1 sui-border-solid sui-border-primary sui-p-3">
      <Typography variant="h6" weight="bold">
        Estimated Total:
        <span className="sui-pl-3 sui-text-5xl">${estimatedTotal}</span>
      </Typography>
      <p className="sui-text-sm">
        Price includes <strong>{coverage} sq. ft.</strong>, full installation of carpet, carpet pad
        and any additional installation materials.
      </p>
    </section>
  );
};

EstimatedTotal.displayName = 'EstimatedTotal';

EstimatedTotal.propTypes = {
  sqFtPrice: number,
};

EstimatedTotal.defaultProps = {
  sqFtPrice: 0,
};
